var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H13.4444C15.1209 1 15.9582 1 16.4791 1.5274C17 2.0548 17 2.9026 17 4.6V10C17 11.6974 17 12.5452 16.4791 13.0726C15.9582 13.6 15.1209 13.6 13.4444 13.6H7.22222M8.11111 5.05H13.4444M1 14.5V10.9C1 10.0513 1 9.6274 1.26044 9.3637C1.52089 9.1 1.93956 9.1 2.77778 9.1H4.55556M1 14.5H4.55556M1 14.5V19M4.55556 9.1V14.5M4.55556 9.1H9.88889M4.55556 14.5V19",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5C5 6.03043 4.78929 6.53914 4.41421 6.91421C4.03914 7.28929 3.53043 7.5 3 7.5C2.46957 7.5 1.96086 7.28929 1.58579 6.91421C1.21071 6.53914 1 6.03043 1 5.5C1 4.96957 1.21071 4.46086 1.58579 4.08579C1.96086 3.71071 2.46957 3.5 3 3.5C3.53043 3.5 4.03914 3.71071 4.41421 4.08579C4.78929 4.46086 5 4.96957 5 5.5Z",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.ed7b8e039cc22adbe274d09ede07beab.svg";
export { ForwardRef as ReactComponent };